module.exports = __webpack_public_path__ + "img/imagen1.74411b2d.png";